import { Trans } from '@lingui/react/macro';
import { useMemo } from 'react';
import UDText from 'ud-ui/components/text';
import { GameDetails } from 'modules/games/domain/interfaces/game-details';
import { getMembers } from 'modules/games/utils/get-members';
import EventCard from './event-card';
import { EventCardSkeleton } from './styles';

interface IProps {
  isLoading: boolean;
  game: GameDetails | null;
}

function EventsList(props: IProps) {
  const { game, isLoading } = props;

  const members = useMemo(() => {
    return game?.teams ? getMembers(game.teams) : {};
  }, [game?.teams]);

  if (isLoading) {
    return (
      <div className="flex flex-col" style={{ gap: 28 }}>
        <EventCardSkeleton className={'skeleton-block'} />
        <EventCardSkeleton className={'skeleton-block'} />
        <EventCardSkeleton className={'skeleton-block'} />
      </div>
    );
  }

  if (!game?.events.length) {
    return (
      <div className={'flex-center w-full'}>
        <UDText type={'title-1'}>
          <Trans>Событий нет</Trans>
        </UDText>
      </div>
    );
  }

  return (
    <div className={'flex flex-col'} style={{ gap: 28 }}>
      {game.events.map((event) => (
        <EventCard key={event.id} event={event} members={members} teams={game.teams} />
      ))}
    </div>
  );
}

export default EventsList;
